/*eslint-disable eqeqeq */
import React from 'react';
import { Row, Col, OverlayTrigger, Popover } from 'react-bootstrap';
import { findPercentage } from '../../../../../Member/utils/common';
import ProgressBar from '../../../progressbar/progressbar';
import { CoverageSVG } from '../../../../img/GlobalSVG';
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});
export const ProgressIndicator = ({
  label,
  applied = 0,
  max,
  Value_Network_For_Coverage_Admin,
  remaining,
}) => {
  const appliedAmount = applied;
  const maxAmount = appliedAmount > max ? appliedAmount : max;
  return (
    <>
      {max === '999999999.99' ? (
        <>
          <div className="no-deduct-oop align-items-center">
            This plan has{' '}
            <span className="no-data">
              <br />
              Unlimited {label}
            </span>
          </div>
        </>
      ) : max != undefined ? (
        //max > '0' &&
        <>
          <Row>
            <Col>
              <div className="">
                <span>
                  {label}&nbsp;
                  <OverlayTrigger
                    delay={{ hide: 450, show: 300 }}
                    overlay={
                      <Popover>
                        <Popover.Content>
                          {Math.floor(findPercentage(appliedAmount, maxAmount))}
                          % Applied
                        </Popover.Content>
                      </Popover>
                    }
                    placement="top"
                  >
                    <span className="">
                      <CoverageSVG.InfoSVG />
                    </span>
                  </OverlayTrigger>
                </span>
              </div>
            </Col>
          </Row>
          <ProgressBar
            completed={findPercentage(appliedAmount, maxAmount)}
            variant="secondary"
            className="coveredcost-progressbar"
          />
          <Row className="clear-both progress-indicators-counts">
            <Col className="text-left">
              <span className="d-block primary-1">Applied</span>
              <p className="primary-1">{formatter.format(appliedAmount)}</p>
            </Col>
            <Col className="text-center">
              <span className="">Remaining</span>
              <p>{formatter.format(remaining)}</p>
            </Col>
            <Col className="text-right">
              <span className="">Maximum</span>
              <p>{formatter.format(max)}</p>
            </Col>
          </Row>
        </>
      ) : (
        <>
          <div className="no-deduct-oop align-items-center">
            {Value_Network_For_Coverage_Admin === 'tier' ? (
              <>
                <h3>This tier has</h3>
              </>
            ) : (
              <>
                <p className="no-data-text">This plan has</p>
              </>
            )}
            <p className="no-data">No {label}</p>
          </div>
        </>
      )}
    </>
  );
};
